import styles from './MagazineShadow.module.scss';
import type { MagazineShadowProps } from './interfaces';

const MagazineShadow = ({ type, hidden }: MagazineShadowProps) => {
  return (
    <div data-type={type} data-hidden={hidden} className={styles.shadow} />
  );
};

export default MagazineShadow;
